import React from 'react';
import { connect } from 'react-redux';
import { scoreUntilScenarioSelector } from '../services/store';

import Chapter from '../components/Chapter';
import Scenario from '../components/Scenario';
import Text from '../components/Text';
import Box from '../components/Box';

const mapStateToProps = (state) => ({
  score: scoreUntilScenarioSelector(4)(state),
});

const Chapter5 = ({
  id,
  trackEvent,
  score,
}) => (
  <Chapter
    id={id}
    theme="green"
    title="10.00 uur, donderdag"
    onEnter={() => trackEvent(id)}
  >
    <Text>Tijd om je score te boosten. Jouw huidige score is te laag.</Text>
    {(score < 560) ? (
      <Scenario
        id="5"
        title="Wat doe je?"
        description="In je brievenbus zit een folder over bloed doneren."
        scoreFirst={0}
        scoreSecond={100}
        buttonTextFirst="Niks"
        buttonTextSecond="Bloed doneren"
        resultTextFirst="Je levert geen positieve bijdrage aan de samenleving."
        resultTextSecond="De overheid beloont maatschappelijke inzet."
        onCallback={(title, choice) => trackEvent(id, choice)}
      />
    ) : (
      <Scenario
        id="5"
        title="Wat doe je?"
        description="Nog een dag om je voor te bereiden op het sollicitatiegesprek. Die score mag wel wat hoger dus."
        scoreFirst={50}
        scoreSecond={30}
        buttonTextFirst="Voor daklozen koken"
        buttonTextSecond="Langs je oma"
        resultTextFirst="De overheid beloont vrijwilligerswerk."
        resultTextSecond="De overheid beloont jongeren die voor hun grootouders zorgen."
        onCallback={(title, choice) => trackEvent(id, choice)}
      />
    )}
    <Box>
      <h3>Wat betekent een lage score?</h3>
      <Text>Met een hoge sociale score krijg je privileges. Je hoeft geen borg te betalen als je een auto of fiets huurt, kunt reserveren bij exclusieve restaurants en businessclass reizen met de trein.</Text>
      <Text>De overheid wil nog verder gaan en ervoor zorgen dat je je lage score écht voelt. Sta je op hun zwarte lijst, dan krijg je geen visum meer en mag je niet meer met het OV reizen. Als klap op de vuurpijl worden je naam en foto getoond op billboards.</Text>
    </Box>
  </Chapter>
);

export default connect(mapStateToProps)(Chapter5);



// WEBPACK FOOTER //
// ./src/chapters/Chapter5.js